import { render, staticRenderFns } from "./newshard.vue?vue&type=template&id=4cd418f7&scoped=true&"
import script from "./newshard.vue?vue&type=script&lang=js&"
export * from "./newshard.vue?vue&type=script&lang=js&"
import style0 from "./newshard.vue?vue&type=style&index=0&id=4cd418f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd418f7",
  null
  
)

export default component.exports